import styled from 'styled-components';
import { Container as BaseContainer } from './Container';
import { Title } from './Container.styles';
import { themeColor } from '../theme/colors';

export const Header = styled.div`
  display: flex;
  margin-bottom: 20px;
  gap: 10px;
  align-items: center;
`;

export const Footer = styled.div`
  &:has(> *) {
    padding-top: 16px;
    padding-bottom: 16px;
  }
`;

export const Container = styled(BaseContainer)`
  background: ${themeColor('tableContainerBackground')};
  border: none;
  padding: 0;
  gap: 0;
  padding-top: var(--padding);

  & ${Title} {
    margin-left: var(--padding);
    margin-right: var(--padding);
    margin-bottom: 20px;
  }

  & ${Footer}, & ${Header} {
    padding-left: var(--padding);
    padding-right: var(--padding);
  }
  /* & ${Footer} {
    border-top: 1px solid ${themeColor('strokeSecondary')};
  } */
`;

export const Filters = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  gap: 12px;
  flex-wrap: wrap;
`;
